import NotificationsPage from "../../components/common/Notification/NotificationPage";
import DashboardLayout from "../../components/Layout/DashboardLayout";

const AdminNotifications = () => {
  return (
    <DashboardLayout pageTitle="Notifications" mainClass="p-6">
      <NotificationsPage type="admin" />
    </DashboardLayout>
  );
};

export default AdminNotifications;
